import { render, staticRenderFns } from "./chgApply.vue?vue&type=template&id=2bd1fb8f&scoped=true&"
import script from "./chgApply.vue?vue&type=script&lang=js&"
export * from "./chgApply.vue?vue&type=script&lang=js&"
import style0 from "./chgApply.vue?vue&type=style&index=0&id=2bd1fb8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1fb8f",
  null
  
)

export default component.exports